export default "__VITE_ASSET__CNGrxBw1__"